/*
 * task-status 任务进度块
 * Schema: { title, steps: [{ label, status: 'done'|'running'|'pending'|'error', detail? }] }
 */
import React from 'react'
import { tryParseJson, TaskStatusData, TaskStatus } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import './TaskStatusBlock.scss'

interface TaskStatusBlockProps {
  code: string
}

const STATUS_ICON: Record<TaskStatus, string> = {
  done: '✓',
  running: '●',
  pending: '○',
  error: '✕'
}

export const TaskStatusBlock: React.FC<TaskStatusBlockProps> = ({ code }) => {
  const data = tryParseJson<TaskStatusData>(code)

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"任务数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = !!data && Array.isArray(data.steps) && data.steps.length > 0
  useInvalidBlockWarning('task-status', code, valid)
  if (!data || !Array.isArray(data.steps) || data.steps.length === 0) {
    return null
  }

  return (
    <div className="aiClerk-block-taskStatus">
      {data.title && (
        <div className="aiClerk-block-taskStatus__title">{data.title}</div>
      )}
      <ol className="aiClerk-block-taskStatus__steps">
        {data.steps.map((s, i) => (
          <li
            key={i}
            className={`aiClerk-block-taskStatus__step aiClerk-block-taskStatus__step--${s.status}`}
          >
            <div className="aiClerk-block-taskStatus__icon">
              {STATUS_ICON[s.status]}
            </div>
            <div className="aiClerk-block-taskStatus__body">
              <div className="aiClerk-block-taskStatus__label">{s.label}</div>
              {s.detail && (
                <div className="aiClerk-block-taskStatus__detail">
                  {s.detail}
                </div>
              )}
            </div>
            {i < data.steps.length - 1 && (
              <div className="aiClerk-block-taskStatus__line" />
            )}
          </li>
        ))}
      </ol>
    </div>
  )
}
